import {
	TGetDocumentDownloadListResponse,
	TGetDocumentListByPageResponse,
} from '@/services';
import { formatDefineDocumentAreaDetail } from '@/stores';

import { map } from 'utils';

import { groupBy } from 'ramda';

export const formatDefineDocumentDownloadDetail = (
	input: TGetDocumentDownloadListResponse[number]
) => {
	return {
		...input,
		fileList: map(input.fileList, formatDefineDocumentAreaDetail),
	};
};

export const formatDefineDocumentDownloadList = (
	input: TGetDocumentDownloadListResponse
) => {
	return map(input, formatDefineDocumentDownloadDetail);
};

export const groupDocumentDownloadByDocumentType = (
	input: TGetDocumentListByPageResponse['content']
) => {
	if (!input?.length) return [];

	const groupedByDocumentType = groupBy((item) => item.documentType, input);

	const result = Object.entries(groupedByDocumentType).map(
		([documentType, fileList]) => ({
			documentType,
			refTableName: fileList[0].refTableName,
			fileList,
		})
	);

	return formatDefineDocumentDownloadList(result);
};

export const groupDocumentDownloadByOwner = (
	input: TGetDocumentListByPageResponse['content']
) => {
	const groupedByOwner = groupBy((item) => item?.refTableId?.toString(), input);

	const result = Object.entries(groupedByOwner).map(
		([refTableId, fileList]) => ({
			refTableId,
			fileList: fileList ?? [],
		})
	);

	return formatDefineDocumentDownloadList(result) ?? [];
};
